"use client";

import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";

interface MeetingDefaults {
  duration_minutes: number;
  buffer_before_minutes: number;
  buffer_after_minutes: number;
  add_conference_link: boolean;
}

interface MeetingDefaultsConfigProps {
  value: MeetingDefaults;
  onChange: (config: MeetingDefaults) => void;
  disabled?: boolean;
}

export function MeetingDefaultsConfig({
  value,
  onChange,
  disabled,
}: MeetingDefaultsConfigProps) {
  const handleChange = (updates: Partial<MeetingDefaults>) => {
    onChange({ ...value, ...updates });
  };

  return (
    <div className="space-y-4">
      {/* Duration */}
      <div className="flex items-center justify-between gap-4">
        <div>
          <Label className="text-sm font-medium">Default Duration</Label>
          <p className="text-xs text-muted-foreground">
            Default meeting length
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Input
            type="number"
            min="15"
            max="120"
            step="15"
            value={value.duration_minutes}
            onChange={(e) =>
              handleChange({ duration_minutes: parseInt(e.target.value) || 30 })
            }
            disabled={disabled}
            className="w-20 text-sm"
          />
          <span className="text-sm text-gray-500">min</span>
        </div>
      </div>

      {/* Buffer Times */}
      <div className="flex items-center justify-between gap-4">
        <div>
          <Label className="text-sm font-medium">Buffer Time</Label>
          <p className="text-xs text-muted-foreground">
            Gap before/after meetings
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Input
            type="number"
            min="0"
            max="30"
            step="5"
            value={value.buffer_before_minutes}
            onChange={(e) =>
              handleChange({
                buffer_before_minutes: parseInt(e.target.value) || 0,
                buffer_after_minutes: parseInt(e.target.value) || 0,
              })
            }
            disabled={disabled}
            className="w-20 text-sm"
          />
          <span className="text-sm text-gray-500">min</span>
        </div>
      </div>

      {/* Google Meet */}
      <div className="flex items-center justify-between gap-4">
        <div>
          <Label className="text-sm font-medium">Google Meet</Label>
          <p className="text-xs text-muted-foreground">
            Auto-add video conference link
          </p>
        </div>
        <Switch
          checked={value.add_conference_link}
          onCheckedChange={(add_conference_link) =>
            handleChange({ add_conference_link })
          }
          disabled={disabled}
        />
      </div>
    </div>
  );
}
